import { useEffect } from "react";
import { matchesGlobalSearchShortcut } from "@/lib/keyboardShortcuts";

type UseGlobalSearchShortcutOptions = {
  onToggle: () => void;
  enabled?: boolean;
};

export default function useGlobalSearchShortcut({ onToggle, enabled = true }: UseGlobalSearchShortcutOptions) {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.repeat) return;
      if (!matchesGlobalSearchShortcut(event)) return;
      if (document.body.dataset.goNavMode === "true") return;

      event.preventDefault();
      onToggle();
    };

    document.addEventListener("keydown", handleKeyDown, true);
    return () => document.removeEventListener("keydown", handleKeyDown, true);
  }, [enabled, onToggle]);
}
